import React, { useState, useEffect, useLayoutEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Button, Layout, notification } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { AiOutlineRight } from "react-icons/ai";
import Logo from "./Logo";
import NavPanel from "./NavPanel";
import NavSearch from "./NavSearch";
import { toggleCollapsedNav, onMobileNavToggle } from "redux/actions/Theme";
import {
  NAV_TYPE_TOP,
  SIDE_NAV_COLLAPSED_WIDTH,
  SIDE_NAV_WIDTH,
} from "constants/ThemeConstant";
import utils from "utils";
import NavProfile from "./NavProfile";
import { Link, useHistory, useLocation } from "react-router-dom";
import AppService from "services/AppService";
import { setLogo, setLogoActive, setLogoLink } from "redux/actions/Auth";
import { API_BASE_URL } from "configs/AppConfig";

const { Header } = Layout;

export const CompanyHeader = (props) => {
  const history = useHistory();
  const {
    token,
    navCollapsed,
    mobileNav,
    headerNavColor,
    toggleCollapsedNav,
    onMobileNavToggle,
    isMobile,
    currentTheme,
    direction,
    listPosition,
    companySlug,
  } = props;
  const navType = "TOP";
  const [searchActive, setSearchActive] = useState(false);
  // const [companySlug , setCompanySlug] = useState('')
  const [companyInfo, setCompanyInfo] = useState(null);

  const location = useLocation();
  const dispatch = useDispatch();

  const onSearchClose = () => {
    setSearchActive(false);
  };

  const onToggle = () => {
    if (!isMobile) {
      toggleCollapsedNav(!navCollapsed);
    } else {
      onMobileNavToggle(!mobileNav);
    }
  };

  const isNavTop = navType === NAV_TYPE_TOP ? true : false;
  const mode = () => {
    if (!headerNavColor) {
      return utils.getColorContrast(
        currentTheme === "dark" ? "#00000" : "#ffffff"
      );
    }
    return utils.getColorContrast(headerNavColor);
  };
  const navMode = mode();
  const getNavWidth = () => {
    if (isNavTop || isMobile) {
      return "0px";
    }
    if (navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`;
    } else {
      return `${SIDE_NAV_WIDTH}px`;
    }
  };

  const fetchCompanyDetails = async () => {
    try {
      const { companyDetails } = await AppService.getCompanyDetails(
        companySlug
      );
      setCompanyInfo(companyDetails);
    } catch (err) {
      console.log(err);
      notification.error({
        message: "Oops! Unable to fetch job details",
      });
    }
  };

  useEffect(() => {
    if (!isMobile) {
      onSearchClose();
    }
    // setCompanySlug(location.pathname.split('/')[location.pathname.split('/').length-1])
  }, []);

  useEffect(() => {
    if (companySlug !== "") {
      fetchCompanyDetails();
    }
  }, [companySlug]);

  useEffect(() => {
    if (location.hash === "#openings") {
      setTimeout(function () {
        window.scrollTo(0, listPosition);
      }, 1000);
    }
  }, [location]);

  useLayoutEffect(() => {
    dispatch(setLogo(`${API_BASE_URL}/image/logo/${companyInfo?.logo}`));
    dispatch(setLogoLink(`/app/home/company/${companyInfo?.slug}`));
    dispatch(setLogoActive(true));
    return () => {
      dispatch(setLogo("/img/One-ATS.svg"));
      dispatch(setLogoLink("/"));
    };
  }, []);

  return (
    <Header
      className={`app-header ${navMode}`}
      style={{
        backgroundColor: headerNavColor,
      }}
    >
      <div
        className={`h-100 app-header-wrapper ${
          isNavTop ? "layout-top-nav" : ""
        }`}
      >
        <Logo
          logoType={navMode}
          isCompany={true}
          companyLink={`/app/home/company/${companyInfo?.slug}`}
        />
        <div className="nav" style={{ width: `calc(100% - ${getNavWidth()})` }}>
          <div className="nav-left">
            <ul className="ant-menu ant-menu-root ant-menu-horizontal">
              {isNavTop && !isMobile ? null : (
                <>
                  <li
                    className="ant-menu-item ant-menu-item-only-child"
                    onClick={() => {
                      onToggle();
                    }}
                  >
                    {navCollapsed || isMobile ? (
                      <MenuUnfoldOutlined className="nav-icon" />
                    ) : (
                      <MenuFoldOutlined className="nav-icon" />
                    )}
                  </li>
                </>
              )}
            </ul>
          </div>
          <div className="nav-right">
            <ul className="header-links">
              <li className="header-link">
                <Link to={`/app/home/company/${companyInfo?.slug}`}>Home</Link>
              </li>
              <li className="header-link ml-4">
                <Link to={`/app/home/company/${companyInfo?.slug}#openings`}>
                  Current Job Opening
                </Link>
              </li>
              <li className="header-link ml-4">
                <Link to="/app/home/applied-jobs">Applied Jobs</Link>
              </li>
              {token === null && (
                <div className="auth-wrapper">
                  <li
                    onClick={() => {
                      history.push("/auth");
                    }}
                    className="mr-0 header-link ml-4"
                  >
                    Log in
                  </li>
                  <li className="header-link ml-4 mr-0">
                    <button
                      onClick={() => {
                        history.push("/auth/register");
                      }}
                    >
                      Sign Up
                    </button>
                  </li>
                </div>
              )}
              {token !== null && (
                <li className="header-link ml-4">
                  <NavProfile />
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </Header>
  );
};

const mapStateToProps = ({ theme, auth }) => {
  const {
    navCollapsed,
    navType,
    headerNavColor,
    mobileNav,
    currentTheme,
    direction,
  } = theme;
  const { token, listPosition, companySlug } = auth;
  return {
    navCollapsed,
    navType,
    headerNavColor,
    mobileNav,
    currentTheme,
    direction,
    token,
    listPosition,
    companySlug,
  };
};

export default connect(mapStateToProps, {
  toggleCollapsedNav,
  onMobileNavToggle,
})(CompanyHeader);
